import './Appointment.css';
import { useState, useEffect } from "react";
import { extractDiv, formatDate } from '../../../service/constants';

const Appointment = (props) => {
    const [data, setData] = useState("")
    useEffect(() => {
        setData(props.getData())
    }, [data, props])

    const [currentIdx, setcurrentIdx] = useState("")

    return (
        <div className="AppointmentContainer">
            {data?.objects?.map((item, idx) => (
                <div className={`AppointmentItem ${currentIdx===idx?"active":""} cursor-pointer`} key={idx} onClick={() => {
                    props.setResourceListData(item)
                    setcurrentIdx(idx)
                    }}>
                    <span className={`AppointmentDate ${idx === data?.objects?.length - 1 ? 'lastRow' : ''}`}>
                        {formatDate(item?.resource?.start)} <br /> {item?.resource?.minutesDuration} minutes
                    </span>
                  {item?.resource?.text?.div &&  <span className={`${idx === data?.objects?.length - 1 ? 'lastRow' : ''} AppointmentText`}>
                        {extractDiv(item?.resource?.text?.div)}
                    </span>}
                </div>
            ))}
        </div>
    );
}

export default Appointment;